import React, { ComponentProps, PropsWithChildren } from "react";

import { AlertDialog } from "../../dialog/alert";
import { Modal } from "../../modal";

import { labels } from "./labels";

export const ProductWarningsDialog = ({
	children,
	onOk,
	...modalProps
}: PropsWithChildren<
	Pick<ComponentProps<typeof AlertDialog>, "onOk"> & ComponentProps<typeof Modal>
>) => {
	const { ok, title } = labels;

	return (
		<AlertDialog onOk={onOk} okLabel={ok} titleLabel={title} {...modalProps}>
			{children}
		</AlertDialog>
	);
};
